import React from 'react'
import { useTranslation } from 'react-i18next'

import { ListItem } from '@ui/components/List'
import { ArrowCircleIcon } from '@ui/icons/ArrowCircle.icon'

import { useWindowResize } from '@utils/domUtils'

import { useIBReferralCodes } from '@hooks/useIBReferralCodes'
import { ScrollToIds } from '@hooks/useScrollToElementIds'
import { useScrollToTop } from '@hooks/useScrollToTop'

import { Box } from '@shared/components/Box'
import { Loading } from '@shared/components/Loading/Loading'

import { SectionHeader } from '../Dashboard/components/SectionHeader/SectionHeader'
import { useIntroducingBrokerLegalDocuments } from '../hooks/useIntroducingBrokerLegalDocuments'

export const LegalDocumentsPage: React.FC = () => {
  useScrollToTop()
  const { legalDocumentsSchemes, isLoading: referralCodesLoading } = useIBReferralCodes()
  const { t } = useTranslation()
  const isMobile = useWindowResize()

  const { data: legalDocuments, isLoading } = useIntroducingBrokerLegalDocuments({
    legalDocumentsSchemes,
  })

  return (
    <Box flex direction='column' gap={isMobile ? 'x24' : 'x32'} mt={isMobile ? 'x16' : undefined}>
      <SectionHeader
        pageHeader
        title={t('Legal Documents')}
        id={ScrollToIds.IBLegalDocumentsHeader}
      />
      <Loading showLoadingIcon isLoading={isLoading || referralCodesLoading}>
        <Box>
          {legalDocuments?.map(({ code, title, url }) => (
            <ListItem
              key={code}
              size='lg'
              title={title}
              link={{ href: url, target: '_blank' }}
              endSlot={{
                icon: {
                  icon: { icon: ArrowCircleIcon.UpRight, color: 'text-med-em' },
                  size: 'x32',
                },
              }}
            />
          ))}
        </Box>
      </Loading>
    </Box>
  )
}
